<template>
  <div class="year-column"
      :class="numQuarters">
  <quarter-column v-for="quarter in yearData.quarters" 
    :key="quarter.quarter" 
    :subcategory="subcategory"
    :catIndex="catIndex"
    :subcatIndex="subcatIndex"
    :quarterData="quarter">
  </quarter-column>
  </div>
</template>

<script>
import QuarterColumn from './QuarterColumn';
import numQuarters from '../../helpers/numQuarters';

export default {
  name: 'year-column',
  props: ['yearData', 'catIndex', 'subcatIndex', 'subcategory'],
  components: {
    'quarter-column': QuarterColumn,
  },
  computed: {
    numQuarters,
  },
};
</script>

<style lang="less">
  .year-column {
    display: flex;
    flex-wrap: wrap;
    margin-right: 7px;
  }
  
  .year-label {
    flex: 0 0 100%;
    font-weight: bold;
  }

</style>



// WEBPACK FOOTER //
// YearColumn.vue?d46b6ae6